import { seriesLoopInstanceNumber } from '@/lib/viewer/seriesShape';
/**
 * "Clip 17" for a series that is one split-out cine loop, else null.
 *
 * Ingest files every loop of an echo exam as a series row of its own, and every
 * one keeps the machine's series number, so the series number and description
 * read the same on all of them. The loop's instance number is what tells them
 * apart; every surface that names a series for a reader to pick puts this label
 * first and falls through to its own chain when it is null.
 *
 * Takes the minimal shape so a worklist thumbnail (no instances) and a viewer
 * series (instances, maybe not loaded yet) both fit; see
 * `seriesLoopInstanceNumber` for where the number comes from.
 */
export function seriesClipLabel(series, t) {
    const number = seriesLoopInstanceNumber(series);
    return number == null ? null : t('common:series.clip', { number });
}
